export default __webpack_public_path__ + "static/media/cara_compliance.dacd8b77.png";